<template>
  <svg
    version="1.0"
    xmlns="http://www.w3.org/2000/svg"
    width="128.000000pt"
    height="128.000000pt"
    viewBox="0 0 128.000000 128.000000"
    preserveAspectRatio="xMidYMid meet"
  >
    <g
      transform="translate(0.000000,128.000000) scale(0.100000,-0.100000)"
      fill="#000000"
      stroke="none"
    >
      <path
        d="M330 982 c-277 -234 -337 -292 -298 -292 7 0 149 115 316 255 l303
256 162 -139 c188 -160 182 -156 203 -144 13 7 -21 41 -168 165 -100 86 -190
157 -198 157 -8 -1 -152 -116 -320 -258z"
      />
      <path
        d="M373 943 c-169 -141 -272 -235 -272 -246 -1 -11 5 -17 13 -15 7 2
129 100 269 218 141 118 260 216 265 218 7 2 166 -127 259 -211 17 -15 28 -18
43 -11 18 8 2 24 -131 137 -83 71 -156 130 -162 133 -7 2 -134 -98 -284 -223z"
      />
      <path
        d="M955 874 c-59 -21 -65 -32 -33 -57 26 -22 27 -22 9 -46 l-18 -24 -98
37 c-54 20 -102 36 -106 36 -5 0 -40 -20 -78 -45 -50 -32 -69 -50 -64 -61 7
-18 17 -15 89 31 l56 36 95 -36 c53 -19 102 -35 110 -35 7 0 26 14 41 31 28
31 29 31 54 15 13 -9 28 -13 31 -9 4 3 7 37 7 75 0 68 0 68 -27 67 -16 0 -46
-7 -68 -15z"
      />
      <path
        d="M1070 868 c0 -18 21 -42 85 -97 77 -65 112 -81 103 -47 -2 7 -37 41
-78 76 -41 35 -83 70 -92 78 -16 14 -18 13 -18 -10z"
      />
      <path
        d="M1070 791 c0 -21 82 -101 105 -101 29 0 14 28 -39 74 -30 25 -57 46
-60 46 -3 0 -6 -8 -6 -19z"
      />
      <path
        d="M215 708 c-20 -18 -39 -47 -44 -64 -11 -38 9 -102 40 -126 21 -18 21
-18 -15 -18 -44 0 -53 -13 -96 -142 -37 -109 -35 -122 26 -134 l34 -6 0 -79 0
-79 33 1 c30 2 30 2 5 6 -28 4 -28 4 -28 89 l0 84 -34 0 c-19 0 -38 5 -41 11
-4 5 10 57 30 115 l38 104 64 0 c73 0 72 2 31 -90 l-21 -45 -7 33 c-10 45 -26
60 -48 46 -41 -26 -18 -145 38 -199 28 -26 30 -34 30 -97 l0 -68 43 1 42 1
-35 12 c-34 13 -35 14 -38 76 -3 56 -7 68 -37 101 -51 57 -71 150 -34 157 13
2 18 -9 23 -48 5 -41 14 -58 45 -89 43 -43 86 -55 145 -42 51 12 104 65 112
110 9 55 15 71 25 71 14 0 11 -88 -5 -118 -8 -15 -26 -38 -40 -51 -23 -22 -26
-32 -26 -91 l0 -66 -37 -11 -38 -10 41 -2 41 -1 7 72 c6 62 11 77 36 103 70
73 82 195 18 195 -21 0 -38 -29 -38 -67 0 -107 -145 -162 -223 -85 -29 29 -30
33 -17 59 l14 28 4 -25 c5 -32 37 -67 68 -74 13 -4 40 0 59 8 70 30 77 117 11
157 -38 23 -64 24 -94 3 -18 -12 -22 -12 -22 -1 0 7 6 21 13 30 11 15 28 17
137 15 l125 -3 22 -45 c31 -63 53 -151 42 -172 -5 -9 -22 -19 -38 -23 -33 -7
-41 -26 -41 -101 0 -50 -1 -52 -32 -59 -30 -7 -31 -8 -9 -12 12 -3 34 -2 47 1
22 6 24 11 24 77 0 58 3 71 18 75 69 21 73 38 33 152 -42 121 -53 139 -90 147
-30 6 -30 7 -11 27 51 55 27 156 -45 192 -33 17 -43 18 -86 7 -34 -9 -53 -10
-68 -2 -40 22 -89 13 -126 -21z m114 -7 c11 -7 11 -15 0 -45 -10 -28 -11 -46
-2 -79 6 -23 9 -44 7 -47 -3 -2 -23 -5 -46 -5 -121 0 -114 181 7 184 11 0 26
-3 34 -8z m154 -2 c46 -21 64 -89 37 -139 -15 -28 -73 -52 -105 -44 -14 3 -36
20 -50 36 -70 82 19 192 118 147z m-68 -304 c14 -13 25 -36 25 -50 0 -14 -11
-37 -25 -50 -13 -14 -36 -25 -50 -25 -33 0 -75 42 -75 75 0 14 11 37 25 50 13
14 36 25 50 25 14 0 37 -11 50 -25z"
      />
      <path
        d="M602 668 c-7 -7 -12 -40 -12 -78 0 -58 3 -70 25 -90 l25 -23 0 76 0
77 45 0 45 0 0 -220 0 -220 -31 0 c-38 0 -69 -16 -69 -36 0 -12 13 -14 73 -12
l72 3 3 259 c2 201 -1 261 -10 268 -20 12 -152 10 -166 -4z"
      />
      <path
        d="M854 617 c-2 -7 -3 -116 -2 -242 l3 -230 84 -3 c61 -2 87 1 92 10 14
22 11 452 -3 466 -17 17 -167 16 -174 -1z m136 -232 l0 -195 -45 0 -45 0 0
195 0 195 45 0 45 0 0 -195z"
      />
      <path
        d="M629 68 c8 -23 10 -23 240 -26 l231 -2 0 25 0 25 -240 0 -239 0 8
-22z"
      />
    </g>
  </svg>
</template>

<script>
export default {}
</script>

<style></style>
